import _each        from 'lodash/each';
import Vue          from 'vue';
import VueMask      from 'v-mask';

import adminComponents  from './components/admin/index';
import publicComponents from './components/public/index';
import store            from './store/index';

Vue.use(VueMask);

window.eventBus = new Vue();
window.Vue = Vue;
window.store = store;

_each(adminComponents, (component, componentCode) => {
    Vue.component(componentCode, component);
});

_each(publicComponents, (component, componentCode) => {
    Vue.component(componentCode, component);
});